import React from 'react';
import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

import { Stage, Layer, Rect, Text, Line } from 'react-konva';
import {
  blueGrey,
  blue,
  grey,
} from '@mui/material/colors'

class SubmissionDetailMindMap extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();
    this.scrollContainerRef = React.createRef();
    this.stageRef = React.createRef();

    // state variables here
    this.state = {
      stageWidth: 375,
      stageHeight: 300,
      boxWidth: 100,
      boxHeight: 40,
      boxPadding: 4,
      linkList: [],
      boxList: [],
      userAnswer: [],
      imageDataUrl: null,
    };
    autoBind(this);
    if (this.props.parent.state.answerData != null && this.props.parent.state.answerData.answer != "") {
      // add try catch to the answer parser
      try{
        this.state.userAnswer = JSON.parse(this.props.parent.state.answerData.answer);
      }
      catch(err){
        console.log("this answer data is problematic");
      }
    }
    // let payload = JSON.parse(this.props.componentData.payload);
    let payload = null;
    const rawPayload = (this.props.componentData != null ? this.props.componentData.payload : null);
    if (rawPayload != null && rawPayload !== "") {
      if (typeof rawPayload === "object") {
        payload = rawPayload;
      } else if (typeof rawPayload === "string") {
        const candidates = [];
        const noNewlines = rawPayload.replace(/[\n\r]/g, '');
        candidates.push(noNewlines);
        candidates.push(
          noNewlines
            .replace(/[“”]/g, '"')
            .replace(/[‘’]/g, "'")
        );

        for (let i = 0; i < candidates.length; i++) {
          try {
            payload = JSON.parse(candidates[i]);
            break;
          } catch (_) {}
        }

        if (payload == null) {
          console.log('the following payload causes the error:');
          for (let i = 0; i < rawPayload.length; i++) {
            console.log(i.toString()+': '+rawPayload[i].charCodeAt(0) + ' ,' + rawPayload[i]);
          }
        }
      }
    }
    if (payload != null) {
      this.state.linkList = (payload.linkList != null? payload.linkList : []);
      this.state.boxList = (payload.boxList != null? payload.boxList : []);
    } else {
      this.state.linkList = [];
      this.state.boxList = [];
    }

    this.updateMindMapBoxDict();
    this.updateStageDimensions();
  }

  componentDidMount() {
    this._mounted = true;
    // Convert Konva canvas to a static image so horizontal scrolling
    // works reliably in all browsers including in-app WebViews.
    this._raf = requestAnimationFrame(() => {
      if (this._mounted && this.stageRef.current) {
        try {
          const stage = this.stageRef.current.getStage();
          const dataUrl = stage.toDataURL({ pixelRatio: 2 });
          this.setState({ imageDataUrl: dataUrl });
        } catch (e) {
          console.log('Failed to convert mind map to image:', e);
        }
      }
    });
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this._raf != null) {
      cancelAnimationFrame(this._raf);
      this._raf = null;
    }
  }

  updateStageDimensions() {
    const { boxList, boxWidth, boxHeight } = this.state;
    if (boxList.length === 0) return;

    let maxX = 375;
    let maxY = 300;
    for (let i = 0; i < boxList.length; i++) {
      const box = boxList[i];
      const right = (box.x || 0) + boxWidth;
      const bottom = (box.y || 0) + boxHeight;
      if (right > maxX) maxX = right;
      if (bottom > maxY) maxY = bottom;
    }

    const padding = 16;
    this.state.stageWidth = maxX + padding;
    this.state.stageHeight = maxY + padding;
  }

  updateMindMapBoxDict() {
    this.state.boxDict = {};
    for (let i = 0; i < this.state.boxList.length; i++) {
      let key = this.state.boxList[i].id;
      if (this.state.boxDict[key] == null) {
        this.state.boxDict[key] = this.state.boxList[i];
      }
    }
  }

  mindMapLink(link) {
    let points = [];
    let point0 = this.state.boxDict[link[0]];
    let point1 = this.state.boxDict[link[1]];
    if (point0 != null) {
      points.push(point0.x + this.state.boxWidth / 2);
      points.push(point0.y + this.state.boxHeight / 2);
    }
    if (point1 != null) {
      points.push(point1.x + this.state.boxWidth / 2);
      points.push(point1.y + this.state.boxHeight / 2);
    }
    let id = points.toString();
    return (
      <Line
        id={id}
        points={points}
        stroke={blueGrey[500]}
        strokeWidth={2}
      />
    )
  }

  mindMapBox(box, index) {
    let boxLabel = "";
    let hasAnswerValue = false;
    // Answer format can be either:
    // - legacy: array indexed by box.id (may include gaps for missing ids)
    // - new: map keyed by box.id (string/number)
    const ans = this.state.userAnswer;
    if (ans != null) {
      if (Array.isArray(ans)) {
        if (box.id != null && box.id >= 0 && box.id < ans.length) {
          if (ans[box.id] != null) {
            hasAnswerValue = true;
            boxLabel = ans[box.id].toString();
          }
        }
      } else if (typeof ans === "object") {
        const v = ans[box.id] != null ? ans[box.id] : ans[box.id?.toString()];
        if (v != null) {
          hasAnswerValue = true;
          boxLabel = v.toString();
        }
      }
    }

    let kind = (box.kind != null? box.kind : 0);
    let x = (box.x != null? box.x : 0);
    let y = (box.y != null? box.y : 0);
    let color = blue[500];

    // If user answer is null/undefined, display empty string for kind=1 boxes
    if (kind === 1 && !hasAnswerValue) {
      boxLabel = "";
    }

    return [
      <Rect
        id={box.id}
        x={x}
        y={y}
        width={this.state.boxWidth}
        height={this.state.boxHeight}
        fill={color}
        cornerRadius={4}
        shadowBlur={4}
        shadowOffsetX={2}
        shadowOffsetY={2}
        shadowOpacity={0.4}
        draggable={false}
      />,
      <If condition={kind==0}>
        <Then>
          <Rect
            x={x + this.state.boxPadding / 2.0}
            y={y + this.state.boxPadding / 2.0}
            fill={'White'}
            width={this.state.boxWidth - this.state.boxPadding}
            height={this.state.boxHeight - this.state.boxPadding}
            cornerRadius={2}
          />
        </Then>
      </If>,
      <Text
        id={box.id}
        name='text'
        x={x + this.state.boxPadding / 2.0}
        y={y + this.state.boxPadding / 2.0}
        text={(kind == 0 ? (box.label != null ? box.label : boxLabel) : boxLabel)}
        fill={kind == 0? 'Black' : 'White'}
        fontSize={12}
        align='center'
        verticalAlign='middle'
        wrap='word'
        width={this.state.boxWidth - this.state.boxPadding}
        height={this.state.boxHeight - this.state.boxPadding}
        draggable={false}
      />
    ]
  }

  renderStage() {
    return (
      <Stage
        ref={this.stageRef}
        width={this.state.stageWidth}
        height={this.state.stageHeight}
        listening={false}
      >
        <Layer>
          <Rect
            x={0}
            y={0}
            width={this.state.stageWidth}
            height={this.state.stageHeight}
            fill={grey[200]}
            cornerRadius={4}
          />
        </Layer>
        <Layer>
          {
            this.state.linkList.map( (link, i) => {
              return (
                this.mindMapLink(link)
              )
            })
          }
        </Layer>
        <Layer>
          {
            this.state.boxList.map( (box, i) => {
              return (
                this.mindMapBox(box, i)
              )
            })
          }
        </Layer>
      </Stage>
    )
  }

  render () {
    if (this.state.imageDataUrl) {
      return (
        <div
          style={{
            overflowX: 'auto',
            maxWidth: '100%',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <img
            src={this.state.imageDataUrl}
            width={this.state.stageWidth}
            height={this.state.stageHeight}
            style={{ display: 'block' }}
            alt="Mind Map"
          />
        </div>
      )
    }

    return (
      <div
        ref={this.scrollContainerRef}
        style={{
          overflowX: 'auto',
          maxWidth: '100%',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {this.renderStage()}
      </div>
    )
  }
}

export default SubmissionDetailMindMap;
